/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Employer/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Employer({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AddAction/Content/Content/SearchTable/Content/Result/Employer"
  
}) {
let insuranceInsurancePlanEmployers0EmployerNameValueData = fromData.useDataValue({ viewPath,
context: 'insurance',
path: 'insurance_plan_employers[0].employer.name',
})
let constantData = '–'
let aggregateData = fromAggregate.getValueOrDefault(insuranceInsurancePlanEmployers0EmployerNameValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="Employer.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insurance.insurance_plan_employers[0].employer.name"
 data="'–'"
 aggregate="/Data/aggregate.js getValueOrDefault"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}